export default __webpack_public_path__ + "static/media/s9.728bed36.jpg";